const WCR_COMPANY_ABBREVIATIONS = {
    16128511: {
        name:"WORLD CLASS ROMANIA SA",
        shortName:"WCR"
    },
    16838691: {
        key:"CLUB SPORT FITNESS CENTER SRL",
        shortName:"CSF"
    },
    24241685: {
        key:"FITNESS SOLUTIONS SRL",
        shortName:"FSO"
    },
    30019625: {
        key:"MOVE ON SRL",
        shortName:"MON"
    },
    30973537: {
        key:"VECTR GYMS SRL",
        shortName:"SMT"
    },
    38569357: {
        key:"NEXTFITNESS & WELLNESS SRL",
        shortName:"NXF"
    },
}

export default WCR_COMPANY_ABBREVIATIONS;

